/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

import BannerItem from '../../../stores/banner/bannerItem';
import ContentParser from '../../contentParser';

const replaceTextPlaceHolders = ({ itemList }, placeHolderMap) => {
    itemList.forEach((bannerItem) => {
        const { textList } = bannerItem;
        textList.forEach((text) => {
            let updatedText = text;
            placeHolderMap.forEach(({ oldString, newString }) => {
                updatedText = updatedText.split(oldString).join(newString);
            });
            textList[textList.indexOf(text)] = updatedText;
        });
    });
};

class BannerUtil {
    contentToBannerModel({
        bannersJson, bannerAdder, onAction, basePath,
        placeHolderMap, appData, subSectionId,
    }) {
        if (subSectionId && bannersJson.itemList) {
            if (this.addBanner({
                banner: bannersJson,
                bannerAdder,
                onAction,
                subSectionFilterKey: subSectionId,
                basePath,
                appData,
            })) {
                return true;
            }
            return false;
        }
        let retVal = false;
        let bannersData = ContentParser.parse(bannersJson);
        if (bannersData && bannersData.items && bannersData.items.length > 0) {
            [bannersData] = bannersData.items;
            Object.keys(bannersData).forEach((key) => {
                const banner = bannersData[key];
                if (typeof banner === 'object') {
                    if (banner.itemList && placeHolderMap && placeHolderMap.length) {
                        replaceTextPlaceHolders(banner, placeHolderMap);
                    }
                    if (this.addBanner({
                        banner,
                        bannerAdder,
                        onAction,
                        subSectionFilterKey: key,
                        basePath,
                        appData,
                    })) retVal = true;
                }
            });
        }
        return retVal;
    }

    addBanner({
        banner, bannerAdder, onAction, subSectionFilterKey, basePath, appData,
    }) {
        let retVal = false;
        const bannerItemList = [];
        if (banner.itemList && banner.itemList.length > 0) {
            retVal = true;
            banner.itemList.forEach((bannerItem) => {
                bannerItemList.push(new BannerItem({
                    name: bannerItem.name,
                    layoutId: bannerItem.layoutID,
                    backgroundColor: bannerItem.backgroundColor,
                    borderColor: bannerItem.borderColor,
                    urlList: bannerItem.urlList,
                    textList: bannerItem.textList
                        ? bannerItem.textList.map(text => ContentParser.processText(text)) : [],
                    buttonList: bannerItem.buttonList,
                    gradient: bannerItem.gradient,
                    imageList: bannerItem.imageList
                        ? bannerItem.imageList.map(image => ContentParser
                            .getAssetPath(image, basePath)) : [],
                    textColor: bannerItem.colorTextList ? bannerItem.colorTextList[0] : undefined,
                    thumbNailImg: bannerItem.thumbNailImg,
                    videoList: bannerItem.videoList,
                    ingestDescription: bannerItem.ingestDescription,
                    backUpImageList: bannerItem.imageList
                        ? bannerItem.imageList.map(image => ContentParser
                            .getAssetPath(image, basePath)) : [],
                    appData,
                    onAction: (urlObj, guid, bannerSectionId, bannerPlatform) => {
                        if (!onAction) {
                            window.open(urlObj.url, '_blank');
                        } else {
                            onAction(urlObj, guid, bannerSectionId, bannerPlatform);
                        }
                    },
                }));
            });
        }
        if (bannerAdder) {
            bannerAdder(banner.layoutID, bannerItemList, subSectionFilterKey);
        }
        return retVal;
    }
}

export default new BannerUtil();
